import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-toggle-icon', {
    mixins: [FormElementMixin],
    props: {
        icon: {
            type: String,
            required: true
        },
        iconTooltip: {
            type: String,
            required: false
        }
    },
    watch: {
        currentValue(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$emit('toggle', newValue);
            }
        }
    }
}, 'form/controls/ak-toggle-icon.html');